module.exports = __webpack_public_path__ + "static/media/29DUNON13.f69c1f25.jpg";